import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import countries from '@swf/generated/countries.json';

import CountrySelect, { findCountry } from '../../../../../CountrySelect/CountrySelect';
import RMFDropDown from '../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_Change,
  TXTCLI_Citizenship,
  TXTCLI_Please_select_your_citizenship,
  TXTWCL_Find_my_country
} from './SelectCitizenshipFlag.messages.json';
import { changeText, selected, withBorder } from './SelectCitizenshipFlag.scss';

const SelectCitizenshipFlag: React.FC = () => {
  const detectedCountry = useSelector(select.account.getCountry);

  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true }, initialValue: detectedCountry });

  return (
    <CountrySelect
      initialValue={citizenship}
      name="citizenship"
      label={TXTCLI_Citizenship}
      title={TXTCLI_Citizenship}
      submit={false}
      hideSelect
    >
      {citizenship ? (
        <CountrySelect.Country
          {...findCountry(citizenship)}
          className={classNames(selected, withBorder)}
          label={TXTCLI_Citizenship}
          selected
          disableRipple
        >
          <span className={changeText}>
            <Translation {...(citizenship ? TXTCLI_Change : TXTWCL_Find_my_country)} />
          </span>
        </CountrySelect.Country>
      ) : (
        <RMFDropDown
          id="citizenship"
          className={selected}
          options={countries}
          label={TXTCLI_Citizenship}
          placeholder={<Translation {...TXTCLI_Please_select_your_citizenship} />}
        />
      )}
    </CountrySelect>
  );
};

export default SelectCitizenshipFlag;
